import { render, staticRenderFns } from "./recruitList.vue?vue&type=template&id=053473ce&scoped=true"
import script from "./recruitList.vue?vue&type=script&lang=js"
export * from "./recruitList.vue?vue&type=script&lang=js"
import style0 from "./recruitList.vue?vue&type=style&index=0&id=053473ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053473ce",
  null
  
)

export default component.exports